import React, { useState, useEffect } from "react";
import {
  Stack,
  Typography,
  Card,
  CardHeader,
  Divider,
  Box,
} from "@mui/material";
import DVHChart from "./DVHChart";
import { loadDVHDataFromFiles } from "./dvhUtils";
import { DVHData } from "./dvhTypes";

interface DVHCardProps {
  isComparisonMode?: boolean;
}

const DVHCard: React.FC<DVHCardProps> = ({ isComparisonMode = false }) => {
  const [planAData, setPlanAData] = useState<DVHData | null>(null);
  const [planBData, setPlanBData] = useState<DVHData | null>(null);
  const [loading, setLoading] = useState(true);

  // Load DVH data on component mount
  useEffect(() => {
    try {
      const { planA, planB } = loadDVHDataFromFiles();
      setPlanAData(planA);
      setPlanBData(planB);
      setLoading(false);
    } catch (_error) {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <Card variant="outlined">
        <CardHeader
          title={<Typography variant="h6">Dose Volume Histogram</Typography>}
          subheader="Dose Volume Histograms for targets and organs at risk."
        />
        <Divider />
        <Stack padding={2} gap={2} sx={{ minHeight: 700 }}>
          <Box
            sx={{
              height: 650,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography>Loading DVH data...</Typography>
          </Box>
        </Stack>
      </Card>
    );
  }

  return (
    <Card variant="outlined">
      <CardHeader
        title={<Typography variant="h6">Dose Volume Histogram</Typography>}
        subheader="Dose Volume Histograms for targets and organs at risk."
      />
      <Divider />
      <Stack padding={2} paddingBottom={4} gap={2} sx={{ minHeight: 700 }}>
        {/* Interactive DVH Chart */}
        <Box sx={{ height: 650 }}>
          {isComparisonMode ? (
            <DVHChart
              planAData={planAData || undefined}
              planBData={planBData || undefined}
              showPlanFilters={true}
            />
          ) : (
            <DVHChart
              dvhData={planAData || undefined}
              showPlanFilters={false}
            />
          )}
        </Box>
      </Stack>
    </Card>
  );
};

export default DVHCard;
